var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "hasPermi",
              rawName: "v-hasPermi",
              value: ["platform:groupbuy:activity:list"],
              expression: "['platform:groupbuy:activity:list']",
            },
          ],
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    size: "small",
                    "label-position": "right",
                    inline: "",
                  },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "活动名称：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { placeholder: "请输入活动名称", clearable: "" },
                        model: {
                          value: _vm.formData.groupName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "groupName", $$v)
                          },
                          expression: "formData.groupName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "inline", attrs: { label: "活动进程：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            clearable: "",
                            placeholder: "请选择活动进程",
                          },
                          on: { change: _vm.selectChange },
                          model: {
                            value: _vm.formData.groupProcess,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "groupProcess", $$v)
                            },
                            expression: "formData.groupProcess",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "未开始", value: "0" },
                          }),
                          _c("el-option", {
                            attrs: { label: "进行中", value: "1" },
                          }),
                          _c("el-option", {
                            attrs: { label: "已结束", value: "2" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "inline", attrs: { label: "活动日期：" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "selWidth",
                        attrs: {
                          type: "date",
                          placeholder: "选择日期",
                          "value-format": "yyyy-MM-dd",
                        },
                        on: { change: _vm.selectChange },
                        model: {
                          value: _vm.formData.startTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "startTime", $$v)
                          },
                          expression: "formData.startTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "inline", attrs: { label: "活动状态：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            clearable: "",
                            placeholder: "请选择活动状态",
                          },
                          on: { change: _vm.selectChange },
                          model: {
                            value: _vm.formData.activityStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "activityStatus", $$v)
                            },
                            expression: "formData.activityStatus",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "开启", value: "1" },
                          }),
                          _c("el-option", {
                            attrs: { label: "关闭", value: "0" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "inline", attrs: { label: "商户分类：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            clearable: "",
                            size: "small",
                            placeholder: "请选择",
                          },
                          on: { change: _vm.selectChange },
                          model: {
                            value: _vm.formData.categoryId,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "categoryId", $$v)
                            },
                            expression: "formData.categoryId",
                          },
                        },
                        _vm._l(_vm.merchantClassify, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商户名称：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { placeholder: "请输入商户名称", clearable: "" },
                        model: {
                          value: _vm.formData.merName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "merName", $$v)
                          },
                          expression: "formData.merName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.search },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        { attrs: { size: "small" }, on: { click: _vm.reset } },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _vm.hedaList.length
            ? _c(
                "el-tabs",
                {
                  staticClass: "list-tabs",
                  on: { "tab-click": _vm.getTabList },
                  model: {
                    value: _vm.formData.groupStatus,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "groupStatus", $$v)
                    },
                    expression: "formData.groupStatus",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: {
                      label: "已通过(" + _vm.hedaList[2].count + ")",
                      name: "4",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      label: "待审核(" + _vm.hedaList[1].count + ")",
                      name: "3",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      label: "已拒绝(" + _vm.hedaList[0].count + ")",
                      name: "1",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-table",
            {
              ref: "multipleTable",
              staticClass: "mt20 tableSelection",
              attrs: { data: _vm.tableData, size: "small", "row-key": "id" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "ID", prop: "id", width: "60" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "活动名称",
                  prop: "groupName",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "活动时间", prop: "time", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.startTime + "至" + scope.row.endTime
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "创建商户", prop: "merName" },
              }),
              _c("el-table-column", {
                attrs: { label: "成团人数", prop: "buyCount" },
              }),
              _c("el-table-column", {
                attrs: { label: "活动进程", prop: "doing" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.groupProcess == 0
                          ? _c("span", [_vm._v("未开始")])
                          : _vm._e(),
                        scope.row.groupProcess == 1
                          ? _c("span", [_vm._v("进行中")])
                          : _vm._e(),
                        scope.row.groupProcess == 2
                          ? _c("span", [_vm._v("已结束")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "参与商品数", prop: "productCount" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "开团数",
                  prop: "totalActivityBegin",
                  "render-header": _vm.totalActivityBeginHeader,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "成团数",
                  prop: "totalActivityDone",
                  "render-header": _vm.totalActivityDoneHeader,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "参团订单数",
                  prop: "totalOrderBegin",
                  "min-width": "100",
                  "render-header": _vm.totalOrderBeginHeader,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "成团订单数",
                  prop: "totalOrderDone",
                  "min-width": "100",
                  "render-header": _vm.totalOrderDoneHeader,
                },
              }),
              _vm.formData.groupStatus == 1
                ? _c("el-table-column", {
                    attrs: { label: "拒绝原因", prop: "refusal", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(scope.row.refusal || "平台强制关闭")
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2960864717
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "活动状态", prop: "status" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.activityStatus == 1
                          ? _c("span", [_vm._v("开启")])
                          : _vm._e(),
                        scope.row.activityStatus == 0
                          ? _c("span", [_vm._v("关闭")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", prop: "operate", "min-width": "155" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["platform:groupbuy:activity:info"],
                                expression:
                                  "['platform:groupbuy:activity:info']",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.toDeatil(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        scope.row.groupStatus != 1
                          ? _c("el-divider", {
                              attrs: { direction: "vertical" },
                            })
                          : _vm._e(),
                        scope.row.groupStatus == 4
                          ? _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: [
                                      "platform:groupbuy:activity:review:close",
                                    ],
                                    expression:
                                      "['platform:groupbuy:activity:review:close']",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.close(scope.row)
                                  },
                                },
                              },
                              [_vm._v("强制关闭")]
                            )
                          : _vm._e(),
                        scope.row.groupStatus == 3
                          ? _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: [
                                      "platform:groupbuy:activity:review:pass",
                                    ],
                                    expression:
                                      "['platform:groupbuy:activity:review:pass']",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.toDeatil(scope.row)
                                  },
                                },
                              },
                              [_vm._v("审核")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-size": _vm.formData.limit,
                  "current-page": _vm.formData.page,
                  total: _vm.total,
                  "page-sizes": [20, 40, 60, 80],
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("activityDetail", {
        ref: "detail",
        on: { changeList: _vm.getTabList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }